import { VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'
import Delivery from '@/dto/deliveries/Delivery'
import deliveryService from '@/services/DeliveryService'
import DictionariesService from '@/services/DictionariesService'
import shipmentStore from '@/stores/ShipmentStore'

export const storageKey: string = 'newDelivery'

@DynamicModule
class CreateDeliveryStore extends VuexModule {
  public model: Delivery | null = null
  private shipmentStore = shipmentStore

  @Mutation
  private setModel(model: Delivery | null) {
    this.model = model

    if (this.model) {
      this.model.shipmentPointId = this.shipmentStore.shipmentPointId
    }
  }

  @Action({ commit: 'setModel' })
  public async setFromExistModel(model: Delivery) {
    const clone = Object.assign({}, model)
    clone.id = null

    return clone
  }

  @Action({ commit: 'setModel' })
  public setClearModel() {
    const model: Delivery = deliveryService.makeDeliveryModel()
    model.weightMeasureUnit = DictionariesService.getDefaultWightUnit()

    return model
  }

  @Action({ commit: 'setModel' })
  public setModelFromLocal() {
    if (this.model) {
      return this.model
    }
    const modelFromLocal = localStorage.getItem(storageKey)

    const model: Delivery = modelFromLocal
      ? JSON.parse(modelFromLocal)
      : deliveryService.makeDeliveryModel()

    if (!model.weightMeasureUnit) {
      model.weightMeasureUnit = DictionariesService.getDefaultWightUnit()
    }

    return model
  }
}

export default getModule(CreateDeliveryStore)
